export default class MenuTrigger {
    constructor(element) {
        this.$element = $(element);
        this.$target = $(this.$element.data('menuTrigger'));
        this.$triggerClose = $(this.$element.data('menuTriggerClose'));
    }

    init() {
        this.$element
            .off('click.menuTrigger', '', $.proxy(this, 'triggerEvent'))
            .on('click.menuTrigger', $.proxy(this, 'triggerEvent'));
    }

    triggerEvent(event) {
        event.preventDefault();
        this.$target.trigger('menuTrigger');
        this.triggerSiblings();
    }

    triggerSiblings () {
        this.$triggerClose.trigger('menuTrigger:close');
    }
}